export function useInvisibleScroll(target) {
  const elementChild = target.childNodes[0];

  const { clientHeight: targetHeight } = target;
  const { clientHeight: childHeight } = elementChild;

  const threshold = Math.ceil(Math.abs(targetHeight - childHeight));

  const range = 15;
  let recuo = 0;

  // wheelEvents
  const wheelEventHandler = ({ deltaY }) => {
    if (deltaY < 0) recuo += range;
    else recuo -= range;

    if (Math.abs(recuo) > threshold) recuo = threshold * Math.sign(recuo);
    if (recuo > 0) recuo = 0;

    elementChild.style.top = `${recuo}px`;
  };

  // touchEvents
  let touchStartY = 0;
  const touchStartEvent = (e) => {
    touchStartY = e.touches[0].clientY;
  };

  const touchMoveEvent = (e) => {
    const touchY = e.touches[0].clientY;
    const deltaY = touchY - touchStartY;

    target.scrollTop -= deltaY;
    touchStartY = touchY;
  };

  const addEvent = () => {
    target.addEventListener('wheel', wheelEventHandler);
    target.addEventListener('touchstart', touchStartEvent);
    target.addEventListener('touchmove', touchMoveEvent);
  };

  const reset = () => {
    elementChild.style.top = '0px';
  };

  // globally
  addEvent();
  elementChild.style.position = 'relative';

  return {
    target,
    elementChild,
    targetHeight,
    childHeight,
    threshold,
    reset,
  };
}
